import { render, staticRenderFns } from "./supplierCouponBuyList.vue?vue&type=template&id=5a999c1a&scoped=true"
import script from "./supplierCouponBuyList.vue?vue&type=script&lang=js"
export * from "./supplierCouponBuyList.vue?vue&type=script&lang=js"
import style0 from "./supplierCouponBuyList.vue?vue&type=style&index=0&id=5a999c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a999c1a",
  null
  
)

export default component.exports